//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueIfBot from 'vue-if-bot/dist/vue-if-bot.es';
import { createCookie, readCookie } from '@/utils/cookie';

export default {
  components: {
    VueIfBot,
  },
  data() {
    return {
      show: undefined,
      cookieName: 'cookieconsent_status',
      cookieExpiryDays: 365,
    };
  },
  computed: {
    hasExistingConsent() {
      const cookie = readCookie(this.cookieName);
      return cookie === '1' || cookie === '0';
    },
  },
  beforeMount() {
    this.show = !this.hasExistingConsent;
  },
  methods: {
    saveConsent(granted) {
      createCookie(this.cookieName, granted ? '1' : '0', this.cookieExpiryDays);

      // Update GTM consent
      if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        const gtagConsent = granted ? 'granted' : 'denied';
        window.gtag('consent', 'update', {
          ad_storage: gtagConsent,
          analytics_storage: gtagConsent,
          ad_user_data: gtagConsent,
          ad_personalization: gtagConsent,
        });
      }

      this.show = false;
    },
    accept() {
      this.$tracking.trackEvent('website.cookie-consent.accept', {
        currentURL: this.$route.fullPath,
      });
      this.saveConsent(true);
    },
    reject() {
      this.$tracking.trackEvent('website.cookie-consent.reject', {
        currentURL: this.$route.fullPath,
      });
      this.saveConsent(false);
    },
  },
};
